import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JobListingComponent } from './job-listing/job-listing.component';
import { JobDetailsComponent } from './job-details/job-details.component';

const routes: Routes = [
  { path: '', redirectTo: 'all', pathMatch: 'full' },

      {
        path: 'all',
        component: JobListingComponent,
      },
      {
        path: 'published',
        component: JobListingComponent
      },
      {
        path: 'unpublished',
        component: JobListingComponent
      },
      {
        path: 'archived',
        component: JobListingComponent
      },
      {
        path: 'create',
        loadComponent: () => import('./add-job/add-job.component').then(m => m.AddJob)
      },
      {
        path: 'edit/:id',
        loadComponent: () => import('./add-job/add-job.component').then(m => m.AddJob)
      },
      {
        path: ':jobId/details',
        component: JobDetailsComponent
      },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobBoardRoutingModule { }
